import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import {
  getNegotiationDetails,
  setForceRecalculation,
  confirmNegotiation,
  getDebtDetails,
  clearDealStatus,
  setDeal,
  getDealState,
  setPhoneCode,
  setEmailCode,
  setAddressCode,
  setAuxiliar,
  setEnableSpecialCheck,
  setAutomaticDebt,
  setNegotiationState,
} from './actions';

const INITIAL_STATE: NegotiationState = {
  list: [],
  forceRecalculation: false,
  error: '',
  billet: '',
  billetLine: '',
  confirmationInfos: null,
  statusNegotiation: undefined,
  dealState: undefined,
  negotiationState: undefined,
  negotiationLoading: false,
};

const proposalReducer = createReducer(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getNegotiationDetails.request, (state, action) => ({
    ...state,
    list: [],
    negotiationLoading: true,
  }))
  .handleAction(getNegotiationDetails.success, (state, action) => ({
    ...state,
    list: action.payload,
    negotiationLoading: false,
  }))
  .handleAction(getNegotiationDetails.failure, (state, action) => ({
    ...state,
    negotiationLoading: false,
  }))
  .handleAction(setNegotiationState.success, (state, action) => ({
    ...state,
    negotiationState: action.payload,
  }))
  .handleAction(setForceRecalculation.request, (state, action) => ({
    ...state,
    forceRecalculation: false,
  }))
  .handleAction(setForceRecalculation.success, (state, action) => ({
    ...state,
    forceRecalculation: action.payload,
  }))
  .handleAction(setForceRecalculation.failure, (state, action) => ({
    ...state,
    forceRecalculation: false,
  }))
  .handleAction(confirmNegotiation.success, (state, action) => ({
    ...state,
    confirmationInfos: action.payload,
  }))
  .handleAction(confirmNegotiation.failure, (state, action) => ({
    ...state,
    confirmationInfos: null,
  }))
  .handleAction(getDebtDetails.success, (state, action) => ({
    ...state,
    debtDetailsInfos: action.payload,
  }))
  .handleAction(getDebtDetails.failure, (state, action) => ({
    ...state,
    debtDetailsInfos: null,
  }))
  .handleAction(setDeal.success, (state, action) => ({
    ...state,
    statusNegotiation: action.payload,
  }))
  .handleAction(getDealState.success, (state, action) => ({
    ...state,
    dealState: action.payload,
  }))
  .handleAction(clearDealStatus, (state) => ({
    ...state,
    statusNegotiation: undefined,
    dealState: undefined,
  }))
  .handleAction(setPhoneCode, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      codigoTelefone: action.payload,
    },
  }))
  .handleAction(setEmailCode, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      codigoEmail: action.payload,
    },
  }))
  .handleAction(setAddressCode, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      codigoEndereco: action.payload,
    },
  }))
  .handleAction(setAuxiliar, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      auxiliar: action.payload,
    },
  }))
  .handleAction(setEnableSpecialCheck, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      autorizaChequeEspecial: action.payload,
    },
  }))
  .handleAction(setAutomaticDebt, (state, action) => ({
    ...state,
    confirmatedInfos: {
      ...state,
      autorizaDebitoAutomatico: action.payload,
    },
  }));

export default proposalReducer;
